export function debounce(fn, delay = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

export async function fetchSection(url, sectionId) {
  const separator = url.includes('?') ? '&' : '?';
  const response = await fetch(`${url}${separator}section_id=${sectionId}`);
  if (!response.ok) throw new Error(`Section fetch failed: ${response.status}`);
  return response.text();
}

export async function postJSON(url, data) {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`Post failed: ${response.status}`);
  return response.json();
}

export function formatMoney(cents) {
  return (cents / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD',
  });
}

export function trapFocus(element) {
  const focusable = element.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
  );
  if (focusable.length === 0) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  element.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  first.focus();
}

function initScrollAnimations() {
  if (!CSS.supports('animation-timeline', 'view()')) return;

  document.querySelectorAll('.animate-on-scroll').forEach((el) => {
    el.style.animationTimeline = 'view()';
    el.style.animationRange = 'entry 0% entry 30%';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollAnimations);
} else {
  initScrollAnimations();
}
